import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { uniqueId } from 'lodash';

const TooltipButton = (props) => {

  const renderTooltip = (p) => (
    <Tooltip className="TooltipButton-tooltip" id={props.id || uniqueId()} {...p}>
      {props.tooltip}
    </Tooltip>
  );

  return (
    <OverlayTrigger
        className="TooltipButton-overlay"
        placement={props.placement || "top"}
        delay={{ show: props.show || 250, hide: props.hide || 400 }}
        overlay={renderTooltip}
    >
      <Button className="TooltipButton-btn" {...props}>{props.content}</Button>
    </OverlayTrigger>
  );
}

export default TooltipButton;